export function scroll(id) {
  const contact = document.getElementById(id);

  if (!contact) {
    throw new Error(`Scroll target not found: ${id}`);
  }

  contact.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function Scroll({ id, children }) {
  return (
    <a
      href="/"
      onClick={(e) => {
        e.preventDefault();
        scroll(id);
      }}
    >
      {children}
    </a>
  );
}
